import { createContext, useContext } from "react";

/** @type {import("react").Context<import("./LocaleProvider.js").LocaleContextValue | null>} */
export const LocaleContext = createContext(null);

/** @returns {import("./LocaleProvider.js").LocaleContextValue} */
export function useLocale() {
  const value = useContext(LocaleContext);
  if (!value) {
    throw new Error("useLocale must be used within LocaleProvider");
  }
  return value;
}
